import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'
import { TileMap } from './tilemap'
interface Props {
  submit: (a: string) => void
}

export const SwissTileMap = ({ submit }: Props) => {
  const [value, setValue] = useState<string>()
  const [formState, setFormState] = useState<'loaded' | 'send' | 'error'>(
    'loaded'
  )
  return (
    <div className='SwissTileMap'>
      <form
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault()
          if (!value) {
            setFormState('error')
            return
          }
          submit(value)
        }}
      >
        <TileMap
          selected={value || ''}
          returnid={e => {
            setValue(e)
          }}
        />

        <div className='actionrow'>
          <button disabled={!value} type='submit'>Antworten</button>
        </div>
      </form>
    </div>
  )
}
